/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const CODE_PADDING_LEFT = `${gridSize()}px`;
export const HIGHLIGHTED_LINE_CLASSNAME = 'highlighted';

export const MonacoWrapper = styled.div<{
  isHidden: boolean;
  isEditing: boolean;
  height: string;
}>`
  display: ${props => (props.isHidden ? 'none' : 'flex')};
  height: ${props => props.height};

  /*
    Set a negative z-index to make sure highlighting from a manual selection
    (ex: click-and-drag) on top of highlighting from an "active" line remains
    visible
    Set a negative 'left' value for the selected row to highlight the entire row
    (both during normal row selection and search). Use '!important' here
    to override the 'left' value provided by Monaco.
  */
  & .monaco-editor .${HIGHLIGHTED_LINE_CLASSNAME} {
    background: ${token('color.background.warning', colors.Y75)};
    z-index: -1;
    left: -${CODE_PADDING_LEFT} !important;
  }

  & .monaco-editor .rangeHighlight {
    left: -${CODE_PADDING_LEFT} !important;
  }

  /*
    There are no plans to add an option to remove the cursor, even in read-only
    mode. \`!important\` is required in order to override inline styles that
    Monaco applies to the cursor with JS.

    https://github.com/Microsoft/monaco-editor/issues/179
  */
  & .monaco-editor .cursor {
    ${props => !props.isEditing && 'display: none !important'};
  }

  & .monaco-editor .line-numbers,
  & .monaco-editor .line-numbers a,
  & .monaco-editor .line-numbers a:hover,
  & .monaco-editor .line-numbers a:focus {
    color: ${token('color.text.subtlest', colors.N300)};
    width: 100%;
    display: block;
  }

  & .monaco-editor .margin-view-overlays {
    border-right: 1px solid ${token('color.border', colors.N40)};
    box-sizing: border-box;
    background: ${token('color.background.input', colors.N10)};
  }

  & .monaco-editor .margin-view-overlays > div .line-numbers {
    left: ${gridSize()}px !important;
  }

  /*
    There's no option for configuring the padding between gutter and code
    (only line number and gutter), nor a gutter border.

    https://github.com/Microsoft/monaco-editor/issues/200
  */

  & .monaco-editor .lines-content {
    padding-left: ${CODE_PADDING_LEFT};
  }
`;
